// extracted by mini-css-extract-plugin
export default {"accordion":"ZqjbX","accordion-title":"sv7uo","accordion-content":"WVMnp"};